'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Clipboard = require('./Clipboard');

var _Clipboard2 = _interopRequireDefault(_Clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Clipboard2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-clipboard/build/index.js
// module id = 85
// module chunks = 0